import * as signalR from '@microsoft/signalr';

// Derive the base URL from the API URL: strip "/api/v1" (or "/api/v1/")
const apiUrl = process.env.VUE_APP_URL_API || '';
const hubBaseUrl = apiUrl.replace(/\/api\/v\d+\/?$/, '');
const HUB_URL = `${hubBaseUrl}/hubs/notification`;

let connection = null;

const notificationService = {

    /**
     * Creates and starts a SignalR connection authenticated with the stored JWT.
     * @param {Function} onSummaryReceived - called with the summary payload
     * @returns {Promise<void>}
     */
    async connect(onSummaryReceived) {
        const token = localStorage.getItem('token');
        if (!token) return;

        connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () => localStorage.getItem('token'),
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Warning)
            .build();

        connection.on('ReceiveNotificationSummary', (summary) => {
            if (onSummaryReceived) {
                onSummaryReceived(summary);
            }
        });

        connection.onreconnected(() => {
            console.log('[SignalR] Reconnected to notification hub.');
        });

        try {
            await connection.start();
            console.log('[SignalR] Connected to notification hub.');
        } catch (err) {
            console.error('[SignalR] Connection error:', err);
        }
    },

    /**
     * Stops the current SignalR connection.
     * @returns {Promise<void>}
     */
    async disconnect() {
        if (connection && connection.state !== signalR.HubConnectionState.Disconnected) {
            try {
                await connection.stop();
                console.log('[SignalR] Disconnected from notification hub.');
            } catch (err) {
                console.error('[SignalR] Disconnect error:', err);
            }
        }
        connection = null;
    },
};

export default notificationService;
